export function headerFunc() {
  toggleMenu()
  initHeaderBlueOnHeroVisibility()
}

/**
 * .p-home-kv または .p-page__header が画面内に見えなくなったら .l-header--blue を付与
 */
function initHeaderBlueOnHeroVisibility() {
  const header = document.querySelector('.l-header')
  const target =
    document.querySelector('.p-home-kv') ||
    document.querySelector('.p-page__header')

  if (!header || !target || typeof IntersectionObserver === 'undefined') {
    return
  }

  // 固定ヘッダー分だけ判定領域の上端を下げる（見えなくなった感覚に合わせる）
  const headerH = header.offsetHeight || 64

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0]
      if (!entry) {
        return
      }
      if (entry.isIntersecting) {
        header.classList.remove('l-header--blue')
      } else {
        header.classList.add('l-header--blue')
      }
    },
    {
      root: null,
      threshold: 0,
      rootMargin: `-${headerH}px 0px 0px 0px`,
    }
  )

  observer.observe(target)
}

const MQ_MD = window.matchMedia('screen and (max-width: 767px)')

/**
 * ハンバーガーメニュー（SP）
 * - 開いている間はスクロール不可
 * - オーバーレイ（メニュー外）タップで閉じる
 */
function toggleMenu() {
  const toggleButton = document.querySelector('.l-header__toggle-button')
  const nav = document.querySelector('.l-header__nav-wrap')
  const overlay = document.querySelector('.l-header__overlay')

  if (!toggleButton || !nav) {
    return
  }

  /** メニュー開閉前のスクロール位置（overflow ロックで TOP に飛ぶのを防ぐ） */
  let menuOpenScrollY = 0

  const isMobile = () => MQ_MD.matches

  const openMenu = () => {
    menuOpenScrollY = window.scrollY || window.pageYOffset || 0
    document.body.style.position = 'fixed'
    document.body.style.top = `-${menuOpenScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.width = '100%'

    toggleButton.classList.add('l-header__toggle-button--close')
    toggleButton.setAttribute('aria-expanded', 'true')
    $(nav).stop().slideDown(300)
    if (overlay) {
      overlay.classList.add('is-active')
      overlay.setAttribute('aria-hidden', 'false')
    }
    document.body.classList.add('is-nav-open')
  }

  const closeMenu = () => {
    if (!toggleButton.classList.contains('l-header__toggle-button--close')) {
      return
    }

    toggleButton.classList.remove('l-header__toggle-button--close')
    toggleButton.setAttribute('aria-expanded', 'false')
    $(nav).stop().slideUp(300)
    if (overlay) {
      overlay.classList.remove('is-active')
      overlay.setAttribute('aria-hidden', 'true')
    }
    document.body.classList.remove('is-nav-open')

    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.width = ''

    window.scrollTo(0, menuOpenScrollY)
  }

  const toggle = () => {
    if (toggleButton.classList.contains('l-header__toggle-button--close')) {
      closeMenu()
    } else {
      openMenu()
    }
  }

  toggleButton.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!isMobile()) {
      return
    }
    toggle()
  })

  if (overlay) {
    overlay.addEventListener('click', () => {
      if (isMobile() && toggleButton.classList.contains('l-header__toggle-button--close')) {
        closeMenu()
      }
    })
  }

  MQ_MD.addEventListener('change', (e) => {
    if (!e.matches) {
      closeMenu()
      $(nav).stop().removeAttr('style')
    }
  })
}
